export default 'Time';